import { APP_HEADER_ID, VIEW_TYPES } from "@/other/constants/OtherKeys.jsx";
import MainHeader from "./MainHeader.jsx";
import ViewSpecificHeader from "./ViewSpecificHeader.jsx";
import useViews from "../../hooks/useViews.jsx";
import { RecentViewsProvider } from "../../context/recentViewsContext.jsx";
import { LayoutGroup } from "motion/react";

const AppHeader = () => {
  const viewManagerState = useViews();
  if (viewManagerState?.selectedView.viewType === VIEW_TYPES.mySwivu) return <></>;
  return (
    <RecentViewsProvider>
      <LayoutGroup>
        <div id={APP_HEADER_ID}>
          {/* Top Header - Application Level */}
          <div className="relative flex justify-between items-center min-h-14 px-5 bg-background border-0 border-b border-b-border border-solid gap-4">
            <MainHeader />
          </div>

          {/* Second Header - View Specific (conditionally rendered) */}
          {viewManagerState?.selectedView.viewType !== VIEW_TYPES.settings && <ViewSpecificHeader />}
        </div>
      </LayoutGroup>
    </RecentViewsProvider>
  );
};

export default AppHeader;